import script from "./ModalCongratulationsResult.vue?vue&type=script&setup=true&lang=ts"
export * from "./ModalCongratulationsResult.vue?vue&type=script&setup=true&lang=ts"

import "./ModalCongratulationsResult.vue?vue&type=style&index=0&id=6aed587e&scoped=true&lang=css"

import exportComponent from "/Users/alessiomealli/WebstormProjects/switaly/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6aed587e"]])

export default __exports__